// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';
import { COLOMBIA_COUNTRY_CODE } from '@tectonics/prs/colombia/constants';

export function validateColombianNequiPhoneNumber(phoneNumberValue: string): ?UserInputValidationError {
  let cleaned = phoneNumberValue.replace(/\D/g, '');

  if (cleaned.startsWith(COLOMBIA_COUNTRY_CODE) && cleaned.length > 10) {
    cleaned = cleaned.substring(COLOMBIA_COUNTRY_CODE.length);
  }

  if (!cleaned?.trim()) {
    return { id: 'empty' };
  } else if (!/^3\d{9}$/.test(cleaned)) {
    return { id: 'invalid-pattern' };
  }
}

export function validateColombianPhoneNumber(phoneNumberValue: string): ?UserInputValidationError {
  const cleaned = phoneNumberValue.replace(/\D/g, '');

  if (!cleaned) {
    return { id: 'empty' };
  } else if (!/^\d{1,20}$/.test(cleaned)) {
    return { id: 'invalid-pattern' };
  }
}
